import { PartnerType } from './SchoolRefReviewForm/constants/enums';

const COMMON_SWITCHER_ITEMS = ['1', '2', '3', '4', '5'];

export const FORM_TEXTS = {
  title: 'Laisser un avis',
  titleNote: '* Les champs munis de ce symbole sont obligatoires',
  userSchoolsData: {
    label: 'Auto-école',
  },
  starsData: {
    label: 'Note globale',
  },
  receptionData: {
    label: 'Accueil',
    caption: 'La qualité des dispositifs d’accueil au téléphone et en agence, l’écoute et la prise en compte de vos demandes.',
    items: COMMON_SWITCHER_ITEMS,
  },
  informationData: {
    label: 'Renseignements',
    caption: 'Les renseignements au moment de l’inscription et l’information sur l’offre de formation (choix de formules, contenu, tarifs).',
    items: COMMON_SWITCHER_ITEMS,
  },
  teachingData: {
    label: 'Moyens pédagogiques',
    caption: 'Les moyens pédagogiques mis à disposition (état et propreté des véhicules, petit matériel, etc).',
    items: COMMON_SWITCHER_ITEMS,
  },
  availabilityData: {
    label: 'Disponibilité',
    caption: 'La disponibilité de l’équipe pédagogique, la facilité à placer des leçons de conduite (fréquences, annulations, etc).',
    items: COMMON_SWITCHER_ITEMS,
  },
  qualityData: {
    label: 'Qualité de formation',
    caption: 'Le contenu et le respect du parcours de formation, la qualité de l’enseignement (telle que vous l’avez perçue).',
    items: COMMON_SWITCHER_ITEMS,
  },
  textarea: {
    label: 'Commentaire',
    rulesLink: 'Voir les critères de publication des avis',
    comment: 'Attention, les avis sont publiés et référencés, soyez courtois, ne citez pas le nom des personnes dans votre commentaire.',
  },
  contactInfoNote: 'Si vous avez effectué votre formation dans plusieurs auto-écoles, merci de renseigner ici les données qui concernent uniquement votre formation dans l’établissement sélectionné.',
  licenseType: {
    label: 'Type de permis',
    placeholder: 'Sélectionner un type',
  },
  drivingLessonsAndFullCost: {
    label: 'Nombre d’heures de conduite et coût total',
    drivingLessonsPlaceholder: 'Heures de conduite',
    fullCostPlaceholder: 'Coût total (en €)',
  },
  theoryAndDrivivngExams: {
    label: 'Nombre de passage au code et à l’examen de conduite',
    theoryExamsPlaceholder: 'Code',
    drivingExamsPlaceholder: 'Conduite',
  },
  contact: {
    label: 'Contact',
    caption: 'Vous gardez l’anonymat et ne serez jamais spammé',
    lastNamePlaceholder: 'Nom',
    firstNamePlaceholder: 'Prénom',
    emailPlaceholder: 'Email',
  },
  practicalExamDate: {
    label: 'Date de la formation',
    placeholder: 'Date de passage de l\'examen',
  },
  minutes: '',
};

export const getFormTexts = (partnerName: string): typeof FORM_TEXTS => {
  if (PartnerType.AvisSolution === partnerName) {
    FORM_TEXTS.practicalExamDate.label = 'Date de l\'examen';
    FORM_TEXTS.teachingData.caption = 'Les moyens pédagogiques mis à disposition.';
    FORM_TEXTS.minutes = '2';
  }

  return FORM_TEXTS;
};

export const SUCCESS_MESSAGE_BODY = 'Votre contribution permettra aux futurs candidats au permis de conduire de mieux choisir leur auto-école.';
export const ERROR_OCCURED = 'Une erreur est survenue.';
